import { render, staticRenderFns } from "./LineClassDayPrice.vue?vue&type=template&id=fa273bce&scoped=true&"
import script from "./LineClassDayPrice.vue?vue&type=script&lang=js&"
export * from "./LineClassDayPrice.vue?vue&type=script&lang=js&"
import style0 from "./LineClassDayPrice.vue?vue&type=style&index=0&id=fa273bce&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa273bce",
  null
  
)

export default component.exports